// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Settings Modal - Ethereal Tech Design
 */

.settings-modal,
.settings-panel {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.settings-panel {
  height: 100%;
  overflow-y: auto;
  padding: var(--spacing-xl) var(--spacing-2xl);
  max-width: 640px;
  margin: 0 auto;
  width: 100%;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: var(--spacing-md);
  border-bottom: 1px solid var(--glass-border);
}

.settings-header h2 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.close-button {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: var(--font-size-2xl);
  cursor: pointer;
  padding: var(--spacing-xs);
  line-height: 1;
  transition: color var(--transition-fast);
}

.close-button:hover {
  color: var(--text-primary);
}

.settings-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}

.settings-section h3 {
  margin: 0 0 var(--spacing-sm) 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  letter-spacing: var(--letter-spacing-wide);
  text-transform: uppercase;
}

.section-description {
  margin: 0 0 var(--spacing-md) 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: var(--line-height-normal);
}

/* Mode Selector */
.mode-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-md);
}

.mode-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-lg);
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-base);
}

.mode-button:hover {
  background: var(--bg-hover);
  border-color: var(--glass-highlight);
}

.mode-button.active {
  background: var(--color-primary-dim);
  border-color: var(--color-primary);
  box-shadow: var(--shadow-glow-primary);
}

.mode-icon {
  font-size: var(--font-size-2xl);
}

.mode-label {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.mode-description {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  text-align: center;
}

.mode-warning {
  margin-top: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--color-warning-glow);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  color: var(--color-warning);
}

/* Providers List */
.providers-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.provider-item {
  padding: var(--spacing-md);
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  transition: border-color var(--transition-fast);
}

.provider-item:hover {
  border-color: var(--glass-highlight);
}

.provider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.provider-checkbox {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  cursor: pointer;
}

.provider-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--color-primary);
  cursor: pointer;
}

.provider-name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.default-radio {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  cursor: pointer;
}

.default-radio input[type="radio"] {
  accent-color: var(--color-primary);
  cursor: pointer;
}

.provider-input-group {
  display: flex;
  gap: var(--spacing-sm);
  margin-top: var(--spacing-md);
}

.provider-input {
  flex: 1;
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  font-family: var(--font-family-mono);
  color: var(--text-primary);
  transition: all var(--transition-fast);
}

.provider-input:focus {
  outline: none;
  border-color: var(--input-focus-border);
  box-shadow: var(--input-focus-glow);
}

.provider-input::placeholder {
  color: var(--text-placeholder);
}

.toggle-visibility {
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--bg-tertiary);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.toggle-visibility:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

/* Inline label + hint link row (e.g. "API Key" + "Get key ↗") */
.field-label-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--spacing-sm);
}

.field-hint-link {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  text-decoration: none;
  transition: color var(--transition-fast);
  white-space: nowrap;
}

.field-hint-link:hover {
  color: var(--color-primary);
}

/* Error */
.settings-error {
  padding: var(--spacing-md);
  background: var(--color-error-glow);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  color: var(--color-error);
}

/* Footer */
.settings-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-md);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--glass-border);
}

.cancel-button,
.save-button {
  padding: var(--spacing-sm) var(--spacing-xl);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.cancel-button {
  background: transparent;
  border: 1px solid var(--glass-border);
  color: var(--text-secondary);
}

.cancel-button:hover {
  background: var(--bg-hover);
  border-color: var(--glass-highlight);
  color: var(--text-primary);
}

.save-button {
  background: var(--color-primary);
  border: none;
  color: white;
}

.save-button:hover:not(:disabled) {
  background: var(--color-primary-hover);
  box-shadow: var(--shadow-glow-primary);
}

.save-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .mode-selector {
    grid-template-columns: 1fr;
  }

  .settings-footer {
    flex-direction: column-reverse;
  }

  .cancel-button,
  .save-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/SettingsModal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAIF;;EAEE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,wCAAwC;EACxC,0BAA0B;EAC1B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,4CAA4C;EAC5C,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;;EAEE,4CAA4C;EAC5C,+BAA+B;EAC/B,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/**\n * Settings Modal - Ethereal Tech Design\n */\n\n@import \"../styles/variables.css\";\n\n.settings-modal,\n.settings-panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.settings-panel {\n  height: 100%;\n  overflow-y: auto;\n  padding: var(--spacing-xl) var(--spacing-2xl);\n  max-width: 640px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: var(--spacing-md);\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.settings-header h2 {\n  margin: 0;\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n}\n\n.close-button {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  font-size: var(--font-size-2xl);\n  cursor: pointer;\n  padding: var(--spacing-xs);\n  line-height: 1;\n  transition: color var(--transition-fast);\n}\n\n.close-button:hover {\n  color: var(--text-primary);\n}\n\n.settings-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xl);\n}\n\n.settings-section h3 {\n  margin: 0 0 var(--spacing-sm) 0;\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  letter-spacing: var(--letter-spacing-wide);\n  text-transform: uppercase;\n}\n\n.section-description {\n  margin: 0 0 var(--spacing-md) 0;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  line-height: var(--line-height-normal);\n}\n\n/* Mode Selector */\n.mode-selector {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-md);\n}\n\n.mode-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-lg);\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.mode-button:hover {\n  background: var(--bg-hover);\n  border-color: var(--glass-highlight);\n}\n\n.mode-button.active {\n  background: var(--color-primary-dim);\n  border-color: var(--color-primary);\n  box-shadow: var(--shadow-glow-primary);\n}\n\n.mode-icon {\n  font-size: var(--font-size-2xl);\n}\n\n.mode-label {\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n.mode-description {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.mode-warning {\n  margin-top: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--color-warning-glow);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-sm);\n  color: var(--color-warning);\n}\n\n/* Providers List */\n.providers-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n.provider-item {\n  padding: var(--spacing-md);\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  transition: border-color var(--transition-fast);\n}\n\n.provider-item:hover {\n  border-color: var(--glass-highlight);\n}\n\n.provider-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.provider-checkbox {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  cursor: pointer;\n}\n\n.provider-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--color-primary);\n  cursor: pointer;\n}\n\n.provider-name {\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n.default-radio {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.default-radio input[type=\"radio\"] {\n  accent-color: var(--color-primary);\n  cursor: pointer;\n}\n\n.provider-input-group {\n  display: flex;\n  gap: var(--spacing-sm);\n  margin-top: var(--spacing-md);\n}\n\n.provider-input {\n  flex: 1;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-sm);\n  font-family: var(--font-family-mono);\n  color: var(--text-primary);\n  transition: all var(--transition-fast);\n}\n\n.provider-input:focus {\n  outline: none;\n  border-color: var(--input-focus-border);\n  box-shadow: var(--input-focus-glow);\n}\n\n.provider-input::placeholder {\n  color: var(--text-placeholder);\n}\n\n.toggle-visibility {\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n}\n\n.toggle-visibility:hover {\n  background: var(--bg-hover);\n  color: var(--text-primary);\n}\n\n/* Inline label + hint link row (e.g. \"API Key\" + \"Get key ↗\") */\n.field-label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: var(--spacing-sm);\n}\n\n.field-hint-link {\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n  white-space: nowrap;\n}\n\n.field-hint-link:hover {\n  color: var(--color-primary);\n}\n\n/* Error */\n.settings-error {\n  padding: var(--spacing-md);\n  background: var(--color-error-glow);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-sm);\n  color: var(--color-error);\n}\n\n/* Footer */\n.settings-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--spacing-md);\n  padding-top: var(--spacing-md);\n  border-top: 1px solid var(--glass-border);\n}\n\n.cancel-button,\n.save-button {\n  padding: var(--spacing-sm) var(--spacing-xl);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.cancel-button {\n  background: transparent;\n  border: 1px solid var(--glass-border);\n  color: var(--text-secondary);\n}\n\n.cancel-button:hover {\n  background: var(--bg-hover);\n  border-color: var(--glass-highlight);\n  color: var(--text-primary);\n}\n\n.save-button {\n  background: var(--color-primary);\n  border: none;\n  color: white;\n}\n\n.save-button:hover:not(:disabled) {\n  background: var(--color-primary-hover);\n  box-shadow: var(--shadow-glow-primary);\n}\n\n.save-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .mode-selector {\n    grid-template-columns: 1fr;\n  }\n\n  .settings-footer {\n    flex-direction: column-reverse;\n  }\n\n  .cancel-button,\n  .save-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
